import type { TemplateFunction, TemplateResult } from 'Components/types';
import { totalHitsSelector } from 'Core/selectors/search';
import { useSelector } from 'Core/store';
import { cloneSafe } from 'Utils/components';

interface Props {
  close: () => void;
  template: TemplateFunction<ShowResultsButtonTemplateParams>;
}

export interface ShowResultsButtonTemplateParams {
  totalHits: number;
}

export default function ShowResultsButton({ close, template }: Props): TemplateResult {
  const totalHits = useSelector(totalHitsSelector);

  const component = template.call({ totalHits });
  return cloneSafe(component, null, { onClick: close });
}
